import { useNavigatePage } from "../../hooks/useNavigatePage";
import Btn from "./Btn";

export default function GoBackBtn() {
  const { onMovementPage } = useNavigatePage();

  return <Btn type="button" title="뒤로" color="green" onClick={() => onMovementPage(-1)} />
}